// Definice workflow konfiguračně, nikoliv v UI (§19). Stavy, přechody, role a
// pravidla. Výchozí je "coordination" workflow dle zadání. Hostitel může předat
// vlastní definici (jiné procesy: závady, přejímky, commissioning…).
export const ROLES = Object.freeze({ REPORTER: "reporter", ASSIGNEE: "assignee", REVIEWER: "reviewer", ADMIN: "administrator" });

// Pravidla (§20) — čisté funkce (topic, ctx) => true|string(chyba). Rozšiřitelné.
export const RULES = {
  requireCommentToClose: (topic, ctx) => ctx.toState !== "closed" || (topic.comments && topic.comments.length > 0) || "Téma nelze uzavřít bez komentáře.",
  requireAssigneeForReview: (topic, ctx) => ctx.toState !== "review" || !!topic.assignedTo || "Téma nelze předat ke kontrole bez odpovědné osoby.",
  dueDateForHighPriority: (topic) => !(topic.priority === "high" || topic.priority === "critical") || !!topic.dueDate || "Termín je povinný pro vysokou prioritu.",
  onlyReviewerCloses: (topic, ctx) => ctx.toState !== "closed" || ctx.role === ROLES.REVIEWER || ctx.role === ROLES.ADMIN || "Uzavřít téma může pouze kontrolor.",
  authorNotApproveOwn: (topic, ctx) => ctx.toState !== "closed" || ctx.userId !== topic.createdBy || ctx.role === ROLES.ADMIN || "Autor nesmí schválit vlastní řešení.",
};

export const coordinationWorkflow = {
  workflow: "coordination",
  states: ["new", "assigned", "in_progress", "review", "closed"],
  initial: "new",
  transitions: {
    new: ["assigned"],
    assigned: ["in_progress"],
    in_progress: ["review"],
    review: ["closed", "in_progress"],       // alternativní větev: vráceno k opravě
    closed: ["in_progress"],                  // znovuotevření
  },
  // Kdo smí provést přechod DO stavu (prázdné = kdokoli). Kontrolní pravidla výše.
  permissions: {
    closed: [ROLES.REVIEWER, ROLES.ADMIN],
  },
  rules: ["requireCommentToClose", "requireAssigneeForReview", "dueDateForHighPriority", "onlyReviewerCloses", "authorNotApproveOwn"],
};

// Sloučí uživatelskou definici s výchozí (mělká) — umožní částečné přepsání.
export function resolveWorkflow(def) {
  if (!def) return coordinationWorkflow;
  return { ...coordinationWorkflow, ...def, transitions: def.transitions || coordinationWorkflow.transitions };
}
